import React, { useState } from "react";
import { RegisterPsychologistApi } from "../services/Api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function PsychologistSignupPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    gender: "Male",
    dob: "",
    address: "",
    education: "",
    profession: "",
    skills: "",
    employment: "",
    about: "",
    languages: [{ name: "English" }, { name: "Spanish" }],
    isAvailableForHomeVisit: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await RegisterPsychologistApi(formData);

    if (response === null) {
      toast.error("Something went wrong please try again later!", {
        position: "top-right",
      });
    } else if (response.status === "success") {
      navigate("/", { replace: true });
      toast.success(response.message, { position: "top-right" });
    } else if (response.status === "failed" || response.status === "failure") {
      toast.error(response.message, { position: "top-right" });
    } else {
      toast.error("Something went wrong please try again later!", {
        position: "top-right",
      });
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-100 to-cyan-100">
      <div className="w-full max-w-3xl bg-white p-8 rounded-lg shadow-xl border border-gray-200">
        <h2 className="text-3xl font-extrabold text-center text-gray-700">
          Psychologist Signup
        </h2>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          {/* Name & Email */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
          </div>

          {/* Phone & Password */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input
              type="tel"
              name="phoneNumber"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
              maxLength={10}
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
          </div>

          {/* Gender & DOB */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
          </div>

          {/* Address */}
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            required
            className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
          />

          {/* Education, Profession, Skills */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <input
              type="text"
              name="education"
              placeholder="Education"
              value={formData.education}
              onChange={handleChange}
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
            <input
              type="text"
              name="profession"
              placeholder="Profession"
              value={formData.profession}
              onChange={handleChange}
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
            <input
              type="text"
              name="skills"
              placeholder="Skills"
              value={formData.skills}
              onChange={handleChange}
              className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
            />
          </div>

          {/* Employment */}
          <input
            type="text"
            name="employment"
            placeholder="Employment"
            value={formData.employment}
            onChange={handleChange}
            className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
          />

          {/* About */}
          <textarea
            name="about"
            placeholder="About Yourself"
            value={formData.about}
            onChange={handleChange}
            className="border-gray-300 border p-3 rounded-lg w-full focus:ring-2 focus:ring-cyan-400"
          ></textarea>

          {/* Submit Button */}
          <button
            type="submit"
            className="bg-[#3CC3CD] text-white py-3 px-6 rounded-lg w-full hover:bg-[#30A7B2] transition"
          >
            Register
          </button>
        </form>
      </div>
    </div>
  );
}

export default PsychologistSignupPage;
